import { Component, OnInit, Input } from '@angular/core';
import { Certification } from 'src/app/shared/models/user';
import { BehaviorSubject } from 'rxjs';
import { MobileUiService } from 'src/app/shared/services/mobile-ui.service';

@Component({
  selector: 'app-profile-certification',
  templateUrl: './profile-certification.component.html',
  styleUrls: ['./profile-certification.component.scss']
})
export class ProfileCertificationComponent implements OnInit {
  @Input() certifications = new BehaviorSubject<Certification[]>([]);
  certificationsHeadElements = ['Org', 'Type', 'Specialty', 'Date'];
  isMobile = new BehaviorSubject<boolean>(false);

  constructor(private mobileUiService: MobileUiService) {
    this.isMobile = this.mobileUiService.isMobile;
  }

  ngOnInit(): void {
  }

}
